module.exports = __webpack_public_path__ + "img/section3_bg.46eb86f4.png";